import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  MoreVert,
  Edit,
  Delete,
  Visibility,
  Download,
} from "@mui/icons-material";

export default function ActionMenu({
  onEdit,
  onDelete,
  onView,
  onDownload,
  item,
}) {
  const [open, setOpen] = useState(false);

  const actions = [
    onView && {
      label: "View",
      icon: Visibility,
      onClick: () => onView(item),
      color: "text-blue-600",
    },
    onEdit && {
      label: "Edit",
      icon: Edit,
      onClick: () => onEdit(item),
      color: "text-primary",
    },
    onDownload && {
      label: "Download",
      icon: Download,
      onClick: () => onDownload(item),
      color: "text-green-600",
    },
    onDelete && {
      label: "Delete",
      icon: Delete,
      onClick: () => onDelete(item),
      color: "text-red-600",
    },
  ].filter(Boolean);

  return (
    <div className="relative">
      <motion.button
        onClick={() => setOpen(!open)}
        className="p-2 rounded-xl hover:bg-gray-100 transition-colors"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <MoreVert className="w-5 h-5 text-gray-600" />
      </motion.button>

      <AnimatePresence>
        {open && (
          <>
            <div
              className="fixed inset-0 z-10"
              onClick={() => setOpen(false)}
            />
            <motion.div
              initial={{ opacity: 0, scale: 0.95, y: -10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.95, y: -10 }}
              className="absolute right-0 top-full mt-2 bg-white rounded-2xl shadow-xl border border-gray-200 py-2 z-20 min-w-[160px]"
            >
              {actions.map((action, index) => {
                const Icon = action.icon;
                return (
                  <motion.button
                    key={action.label}
                    initial={{ opacity: 0, x: -10 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ delay: index * 0.05 }}
                    onClick={() => {
                      action.onClick();
                      setOpen(false);
                    }}
                    className={`w-full px-4 py-2.5 text-left flex items-center gap-3 hover:bg-gray-50 transition-colors ${action.color}`}
                  >
                    <Icon className="w-4 h-4" />
                    <span className="text-sm font-medium">{action.label}</span>
                  </motion.button>
                );
              })}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
